module.exports = __webpack_public_path__ + "static/media/humana.0416515c.webp";